import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import ReactResizeDetector from 'react-resize-detector';
import StageDisplay from '../opportunity-box/Stage';

import FeedbackForm from './feedback-form';
import { getViewableDimensions } from '../../../App/AppReducer';


class SellerFeedbackModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opportunity: null,
      headerHeight: 0,
      footerHeight: 0,
      submitted: false,
    };
    this.close = this.close.bind(this);
    this.onExited = this.onExited.bind(this);
    this.handleSuccess = this.handleSuccess.bind(this);
    this.hanldeHeaderResize = this.hanldeHeaderResize.bind(this);
    this.hanldeFooterResize = this.hanldeFooterResize.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const currentId = this.props.opportunity ? this.props.opportunity.opportunity_id : null;
    if (nextProps.opportunity && nextProps.opportunity.opportunity_id !== currentId) {
      this.setState({ opportunity: nextProps.opportunity, submitted: false });
    }
  }

  onExited() {
    this.props.onClose();
  }

  close() {

  }

  handleSuccess() {
    this.setState({ submitted: true }, () => {
      this.props.onSuccess();
    });
  }

  hanldeHeaderResize(w, headerHeight) {
    this.setState({ headerHeight });
  }
  hanldeFooterResize(w, footerHeight) {
    this.setState({ footerHeight });
  }

  renderTitle() {
    const { opportunity } = this.state;
    let acc = null;
    if (opportunity.account) {
      acc = (<span>at {opportunity.account.name}</span>);
    }
    return (
      <span>
        Reasons We <span className="text-capitalize"><StageDisplay value={opportunity.stage} /></span> {acc}
      </span>
    );
  }
  

  render() {
    const { viewableDimensions: { height } } = this.props;
    const {
      opportunity, footerHeight, headerHeight,
      submitted,
    } = this.state;

    const remainingHeight = Math.max(0, height - footerHeight - headerHeight - 60); // margin: 30

    const open = this.props.opportunity && this.props.opportunity.opportunity_id !== undefined;
    if (!opportunity) {
      return null;
    }
    return (
      <Modal
        show={open}
        onHide={this.onExited}
        onExited={this.onExited}
        bsSize="lg"
      >
        <div>
          <Modal.Header closeButton>
            <Modal.Title>{this.renderTitle()}</Modal.Title>
          </Modal.Header>
          <ReactResizeDetector handleHeight onResize={this.hanldeHeaderResize} />
        </div>
        <Modal.Body>
          <FeedbackForm
            opportunity={opportunity}
            collectorTypes={this.props.collectorTypes}
            onSuccess={this.handleSuccess}
            maxHeight={remainingHeight}
          />
        </Modal.Body>
      </Modal>
    );
  }
}

SellerFeedbackModal.propTypes = {
  opportunity: PropTypes.shape({
    opportunity_id: PropTypes.string,
    name: PropTypes.string,
  }),
  onClose: PropTypes.func,
  collectorTypes: PropTypes.arrayOf(PropTypes.string),
  viewableDimensions: PropTypes.shape({
    height: PropTypes.number,
  }),
  onSuccess: PropTypes.func,
};
SellerFeedbackModal.defaultProps = {
  opportunity: null,
  onClose: () => {},
  collectorTypes: [],
  viewableDimensions: {
    height: 0,
  },
  onSuccess: () => {},
};
SellerFeedbackModal.contextTypes = {
};

function mapStateToProps(state) {
  return {
    viewableDimensions: getViewableDimensions(state),
  };
}
export default connect(mapStateToProps)(SellerFeedbackModal);